import Hero from "@/components/home/Hero";
import Marquee from "@/components/home/Marquee";
import Opportunity from "@/components/home/Opportunity";
import Solutions from "@/components/home/Solutions";
import Calculator from "@/components/home/Calculator";
import Process from "@/components/home/Process";
import QuoteForm from "@/components/quote/QuoteForm";
import { Reveal, Eyebrow } from "@/components/Reveal";

export default function Home() {
  return (
    <main>
      <Hero />
      <Marquee />
      <Opportunity />
      <Solutions />
      <Calculator />
      <Process />

      <section id="quote" className="py-24 sm:py-32 lg:py-40 px-4 sm:px-8 lg:px-16" data-testid="quote-section">
        <div className="max-w-3xl mx-auto">
          <Reveal>
            <Eyebrow>Start Your Project</Eyebrow>
            <h2 className="font-display font-bold uppercase tracking-tight text-2xl sm:text-3xl lg:text-4xl leading-tight mb-4">
              Request a Project Quote
            </h2>
            <p className="text-muted-green text-sm sm:text-base leading-relaxed mb-12 max-w-xl">
              Tell us about your facility. A Fairlume lighting specialist will review your
              brief and respond within one business day.
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="bg-card-dark border hairline rounded-md p-7 sm:p-10 grain relative">
              <QuoteForm />
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
